import React, {ComponentPropsWithoutRef, FC, ReactNode} from 'react';

import CloseCircleButton from '@/components/CloseButton/CloseCircleButton';
import useIsMobileLayout from '@/hooks/layout/useIsMobileLayout';
import {twx} from '@/utils/tailwindUtils';

interface IHeaderProps extends ComponentPropsWithoutRef<'div'> {
    children?: ReactNode;
    handleClose?: () => void;
}

export const Header: FC<IHeaderProps> = ({children, handleClose, className}) => {
    const isMobile = useIsMobileLayout();

    return (
        <div className={twx('flex w-full items-center justify-end', className)}>
            {children}
            {/* @ts-ignore */}
            {handleClose && <CloseCircleButton fill={isMobile ? 'none' : 'black'} onClick={handleClose} />}
        </div>
    );
};
